import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import React from "react";
import PipeCard from "../../../pipe-common/PipeCard";
import UseSorensenXgControl from "./hooks/UseSorensenXgControl";

export default function SorensenXgControl({pipe, handleSettingsChanged, handleSettingsApply}) {
    const {
        settings,
        applying,
        hasErrors,
        validationErrors,
        handleMainOutputControlChanged,
        handleCurrentSetPointChanged,
        handleVoltageSetPointChanged,
        handleApplyClick
    } = UseSorensenXgControl({pipe, onChanged: handleSettingsChanged, onApply: handleSettingsApply});

    return (
        <PipeCard
            title={pipe.title}
            status={"INACTIVE"}
            content={
                <Grid container direction={"column"} alignItems={"center"} spacing={2}>
                    <Grid item xs={12}>
                        <FormControl>
                            <FormGroup row>
                                <FormControlLabel
                                    value="main_output_control"
                                    control={
                                        <Switch checked={settings.mainOutputControl}
                                                onChange={(e) => {
                                                    handleMainOutputControlChanged(e.target.checked);
                                                }}
                                        />
                                    }
                                    label={
                                        <Typography style={{fontSize: "0.9rem"}}>
                                            Main Output Control
                                        </Typography>
                                    }
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} container direction={"row"} justify={"center"} spacing={2}>
                        <Grid item xs>
                            <TextField
                                id="current-set-point"
                                type={"number"}
                                label="Current Set Point"
                                value={settings.currentSetPoint}
                                error={validationErrors["current_set_point"]}
                                inputProps={{
                                    step: 0.1,
                                    style: {textAlign: "center"}
                                }}
                                onChange={(e) => handleCurrentSetPointChanged(e.target.value)}
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                id="voltage-set-point"
                                type={"number"}
                                label="Voltage Set Point"
                                value={settings.voltageSetPoint}
                                error={validationErrors["voltage_set_point"]}
                                inputProps={{
                                    step: 0.1,
                                    style: {textAlign: "center"}
                                }}
                                onChange={(e) => handleVoltageSetPointChanged(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            }
            bottom={
                <Button size="small"
                        variant="contained"
                        color="primary"
                        disabled={applying || hasErrors}
                        onClick={handleApplyClick}
                >
                    Apply
                </Button>
            }
        />
    );
}